module.exports = __webpack_public_path__ + "img/MOBILE-VTA-VALORACION-MODIFICAR02.33bfb1b1.png";